import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import { Grid } from "@material-ui/core";

const TableRelatorios = ({ data, status }) => {
  const headerTitles = Object.keys(status);
  const headerSubtitles = Object.values(status);

  return (
    <TableContainer
      component={Paper}
      style={{
        border: "1px solid rgba(0, 0, 0, .125)",
        borderRadius: "10px",
        marginTop: "1rem"
      }}
    >
      <Table
        size="small"
        style={{
          width: "100%",
          borderRadius: "5px"
        }}
      >
        <TableHead style={{ borderRadius: "10px", backgroundColor: "#DADADA" }}>
          <TableRow>
            <TableCell
              align={"center"}
              style={{
                border: "1px solid rgba(0, 0, 0, .125)",
                borderRadius: "8px 0 0 10px"
              }}
            >
              Nível
            </TableCell>
            {headerTitles && headerTitles.map((element, i) => (
              <TableCell
                align={"center"}
                style={{
                  borderRadius:
                    i === headerTitles.length - 1 ? "0 8px 10px 0" : "",
                  border: "1px solid rgba(0, 0, 0, .125)",
                }}
              >
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    {element}
                  </Grid>
                  <Grid item xs={12}>
                    {headerSubtitles[i]}
                  </Grid>
                </Grid>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {data && data.map((row, i) => (
            <TableRow
              key={row.nivel}
              style={{
                backgroundColor: i % 2 === 0 ? "#ededed" : "#f7f7f7",
                borderRadius:
                  i === headerTitles.length - 1 ? "0 8px 10px 0" : ""
              }}
            >
              <TableCell
                component="th"
                scope="row"
                align={"center"}
                style={{
                  borderRadius:
                    i === headerTitles.length - 1 ? "0 8px 10px 0" : "",
                  border: "1px solid rgba(0, 0, 0, .125)",
                }}
              >
                {row.nivel}
              </TableCell>
              {row &&
                row.dados.map((data, key) => (
                  <TableCell
                    component="th"
                    scope="row"
                    align={"center"}
                    style={{
                      border: "1px solid rgba(0, 0, 0, .125)",
                    }}
                  >
                    {data}
                  </TableCell>
                ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TableRelatorios;
